import { IObjectUpdate, IMfilesPropertyUpdate, IOwnPropertyUpdate } from "../../rematch/interfaces/IObjectUpdate";

const revertUpdate = (update: IObjectUpdate): IObjectUpdate => {
  return {
    ...update,
    mfPropertyUpdates: update.mfPropertyUpdates.map(revertMfilesUpdate),
    ownPropertyUpdates: update.ownPropertyUpdates.map(revertOwnPropertyUpdate),
  };
};

const revertMfilesUpdate = (mfilesUpdate: IMfilesPropertyUpdate): IMfilesPropertyUpdate => {
  return {
    ...mfilesUpdate,
    newValue: mfilesUpdate.oldValue,
    oldValue: mfilesUpdate.newValue,
  };
};

const revertOwnPropertyUpdate = (ownPropertyUpdate: IOwnPropertyUpdate): IOwnPropertyUpdate => {
  return {
    ...ownPropertyUpdate,
    newValue: ownPropertyUpdate.oldValue,
    oldValue: ownPropertyUpdate.newValue,
  };
};

export { revertUpdate };
